import {TableCell} from '@mui/material'
import {React, styled} from 'common'
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import useTableAction from 'logic/useTableAction'
import {showDeleteAlert} from 'services/alert'
import {useTranslation} from 'react-i18next'
import ListActions from './TableAction/ListActions'
import {useMemo, useState} from 'react'
import CustomMenuItem from 'components/Control/ActionMenuItem/CustomMenuItem'
import {useAuthorization} from 'logic/useAuthorization'
const TableAction = ({
    allowEdit,
    allowDelete,
    itemName,
    tableName,
    onClickDelete,
    onClickEdit,
    onClickExpand,
    isExpanded,
    itemId,
    tableRowData,
    tableActions = [],
}) => {
    const {t} = useTranslation()
    const {isSuper} = useAuthorization()
    const [anchorEl, setAnchorEl] = useState(null)
    const {handleDelete, handleEdit, MoreDetailsIcon} = useTableAction(
        itemName,
        tableName,
        itemId,
        tableRowData,
        onClickDelete,
        onClickEdit,
        isExpanded
    )

    const actionItems = useMemo(() => {
        const actions = [...tableActions]

        if (allowEdit) {
            actions.push({
                MenuItem: CustomMenuItem,
                onClick: (e) => {
                    e.stopPropagation()
                    handleEdit(tableRowData)
                },
                title: 'edit',
                Icon: BorderColorRoundedIcon,
            })
        }

        if (allowDelete) {
            actions.push({
                MenuItem: CustomMenuItem,
                onClick: (e) =>
                    showDeleteAlert(e, t('modal.delete_title'), handleDelete, null, true, t),
                title: 'delete',
                Icon: DeleteOutlineRoundedIcon,
            })
        }

        return actions
    }, [allowEdit, allowDelete, handleDelete, handleEdit, tableRowData, t, tableActions])

    return (
        <TableCell style={{width: '50px'}}>
            <Container>
                {onClickExpand && isSuper() && (
                    <MoreDetailsIcon
                        sx={{cursor: 'pointer'}}
                        onClick={(e) => {
                            e.stopPropagation()
                            onClickExpand(isExpanded ? null : itemId)
                        }}
                    />
                )}
                {actionItems && (
                    <ListActions
                        setAnchorEl={setAnchorEl}
                        anchorEl={anchorEl}
                        options={actionItems}
                        itemId={itemId}
                        tableRowData={tableRowData}
                    />
                )}
            </Container>
        </TableCell>
    )
}

export default TableAction

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`
